import { css } from 'lit';

export const styles = css`
  :host(:not(:last-child)) > div:not(.barrel-wrapper-closed) {
    padding-bottom: calc(40rem / var(--default-rem-px-count));
  }

  /* Barrel headers are small UI labels that happen to use h3 for
     structure. The bare h3 default is a full-size heading, so the label
     sizes are pinned here instead. */
  h3 {
    font-weight: 400;
    font-size: calc(10rem / var(--default-rem-px-count));
    line-height: calc(16rem / var(--default-rem-px-count));
  }

  @media (min-width: 600px) {
    h3 {
      font-size: calc(16rem / var(--default-rem-px-count));
      line-height: calc(20rem / var(--default-rem-px-count));
      letter-spacing: normal;
    }
  }

  ul.no-bullets {
    list-style-type: none;
    margin: 0;
  }

  ul.no-bullets li {
    padding-bottom: calc(20rem / var(--default-rem-px-count));
  }

  .barrel-wrapper-closed {
    height: calc(60rem / var(--default-rem-px-count));
    overflow: hidden;
  }

  .barrel-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: calc(60rem / var(--default-rem-px-count));
    border-top: 2px solid #222222;
    cursor: pointer;
  }

  .barrel-header span {
    display: flex;
    align-items: center;
  }

  .barrel-heavy-text {
    font-weight: 500;
  }

  li,
  .barrel-text {
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    font-size: calc(9rem / var(--default-rem-px-count));
    letter-spacing: -0.05px;
    line-height: 12px;
  }

  /* MATERIAL BARREL */
  .material-row-wrapper {
    width: 100%;
    display: inline-grid;
    grid-template-columns:
      [mat-header]
      30%
      [mat-value]
      auto
      [end];
    padding-top: calc(24rem / var(--default-rem-px-count));
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    gap: 0 1em;
  }

  .material-row-wrapper:not(:last-child) {
    border-bottom: 1px solid var(--block-rule-color, #c0c0c0);
  }

  .material-row-wrapper:nth-child(2) {
    padding-top: calc(14rem / var(--default-rem-px-count));
  }

  .material-row-wrapper:last-child {
    padding-bottom: 0;
  }

  .material-row-wrapper.total {
    background-color: #f8f8f8;
    margin: 0 calc(-20rem / var(--default-rem-px-count));
    padding: 0 calc(20rem / var(--default-rem-px-count))
      calc(20rem / var(--default-rem-px-count))
      calc(20rem / var(--default-rem-px-count));
  }

  .material-row-header {
    grid-area: mat-header;
  }

  .material-row-value {
    grid-area: mat-value;
  }

  .row-content-text p:not(:last-child) {
    padding-bottom: calc(8rem / var(--default-rem-px-count));
  }

  .total-disclaimer {
    grid-row: 3;
    grid-column: 1 / 3;
    padding-top: calc(16rem / var(--default-rem-px-count));
    padding-bottom: calc(16rem / var(--default-rem-px-count));
  }

  .line-space-above {
    padding-top: calc(16rem / var(--default-rem-px-count));
  }

  @media print {
    .material-row-wrapper.total {
      background-color: #f8f8f8;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .barrel-header {
      border-top: 1px solid #222222;
    }

    .material-row-wrapper:not(:last-child) {
      border-bottom: 0.75px solid var(--block-rule-color, #c0c0c0);
    }

    .barrel-heavy-text {
      font-size: 10px;
      letter-spacing: -0.05px;
      line-height: 18px;
    }

    .material-row-wrapper p {
      font-size: 9px;
      letter-spacing: -0.05px;
      line-height: 12px;
    }
  }
`;
